import React, { useState } from "react";
import LoginIcon from "@mui/icons-material/Login";
import { Box, Button, Grid } from "@mui/material";
import LoginPopUp from "../LoginPopUp";
import HeaderMenu from "src/layouts/CollapsedSidebarLayout/Header/Menu";

export default function PublicViewHeader(props) {
    const [showLogInPopUP, setShowLogInPopUP] = useState(false);
    return (
        <>
            <div style={{ height: "80px" }} />
            <Grid
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                    padding: "18px",
                    backgroundColor: "white",
                    boxShadow: 1,
                    position: "fixed",
                    width: "100%",
                    zIndex: "100",
                    top: 0
                }}
            >
                <Box display="flex" alignItems="center" sx={{ width: "100%", justifyContent: "flex-start" }}>
                    <img src="/mrkt365logo_small.png" alt="Marketplace" style={{ objectFit: "contain" }} />
                    <Box
                        component="span"
                        sx={{
                            display: {
                                xs: "none",
                                width: "100%",
                                position: "relative",
                            },
                            "@media screen and (min-width: 1200px)": {
                                display: "inline-block",
                            },
                        }}
                    >
                        <HeaderMenu />
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                    <Button onClick={() => setShowLogInPopUP(true)} startIcon={<LoginIcon />} variant="outlined">
                        Login
                    </Button>
                </Box>
                {showLogInPopUP ? (
                    <LoginPopUp showLogInPopUP={showLogInPopUP} setShowLogInPopUP={setShowLogInPopUP} />
                ) : null}
            </Grid>
        </>
    );
}
